import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";

export const ResultDropdownHeader: React.FC<{ sectionHeader: string }> = ({
  sectionHeader,
}) => (
  <Row className="pb-2">
    <Spacer width="2x" />
    <Typography variant="paragraphSansMedium" role="heading">
      {sectionHeader}
    </Typography>
  </Row>
);
